import * as _ from "../../../../constants/Constants";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";

const getStatusClass = (value) =>
  value === _.PENDING ||
  value === _.REJECTED ||
  value === _.DVN_SETUP_STATUS_COMPLETE ||
  value === _.DVN_SETUP_STATUS_ERROR
    ? "circleYellowSmaller"
    : value === _.APPROVED
    ? "circleGreenSmaller"
    : "circleGraySmaller";

export const companyInfoAccordion = {
  eventKey: "0",
  accordionName: _.VP_MA_SB_CI_HEAD,
  linkInfo: [
    {
      path: (profileId) => `/boarding/vendor/company/${profileId}`,
      linkName: _.VP_MA_SB_CI_COMPANY_DET,
      pageRoleId:
        rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_COMPANYDETAILS,
      statusColor: (status) => getStatusClass(status?.[_.MERCHANT_APPROVAL_ID]),
    },
    {
      path: (profileId) => `/boarding/vendor/address/${profileId}`,
      linkName: _.VP_MA_SB_CI_ADDRESS_DET,
      pageRoleId:
        rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_ADDRESSDETAILS,
      statusColor: (status) => getStatusClass(status?.[_.MERCHANT_APPROVAL_ID]),
    },
    {
      path: (profileId) => `/boarding/vendor/contact/${profileId}`,
      linkName: _.VP_MA_SB_CI_CONTACT_DET,
      pageRoleId:
        rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_CONTACTDETAILS,
      statusColor: (status) => getStatusClass(status?.[_.MERCHANT_APPROVAL_ID]),
    },
    {
      path: (profileId) => `/boarding/merchant/${profileId}`,
      linkName: _.VP_MA_SB_CI_MERCH_APP,
      pageRoleId:
        rolePermConsts.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
      statusColor: (status) => getStatusClass(status?.[_.MERCHANT_APPROVAL_ID]),
    },
  ],
};

export const preBoardingAccordion = {
  eventKey: "1",
  accordionName: _.VP_MA_SB_PB_HEAD,
  linkInfo: [
    {
      id: _.UPLOAD_DOCUMENT_ID,
      path: (profileId) => `/boarding/vendor/documentCenter`,
      linkName: _.VP_MA_SB_PB_DOC_CENTER,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
      statusColor: (status) => getStatusClass(status?.[_.UPLOAD_DOCUMENT_ID]),
    },
    {
      id: _.EIN_VERIFICATION_ID,
      path: (profileId) => `/boarding/vendor/einverification/${profileId}`,
      linkName: _.VP_MA_SB_PB_EIN_VERIFICATION,
      pageRoleId: null,
      statusColor: (status) => getStatusClass(status?.[_.EIN_VERIFICATION_ID]),
      displayFor: _.DISPLAY_FOR_MP,
    },
    {
      id: _.DVN_SET_UP_ID,
      path: (profileId) => `/boarding/vendor/dvnsetup/${profileId}`,
      linkName: _.VP_MA_SB_PB_SET_DVN,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNSETUP,
      statusColor: (status) => getStatusClass(status?.[_.DVN_SET_UP_ID]),
    },
    {
      id: _.DVN_AUDIT_ID,
      path: (profileId) => `/boarding/vendor/dvnaudit/${profileId}`,
      linkName: _.VP_MA_SB_PB_DVN_AUDIT,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PREBOARDING_DVNAUDIT,
      statusColor: (status) => getStatusClass(status?.[_.DVN_AUDIT_ID]),
      displayFor: _.DISPLAY_FOR_ALL_DVN_AUDIT,
    },
    {
      id: _.UPLOAD_CONTRACT_ID,
      path: (profileId) => `/boarding/ops/11/${profileId}`,
      linkName: _.VP_MA_SB_PB_SIGN_CONTRACT,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PREBOARDING_REVIEWCONTRACT,
      statusColor: (status) => getStatusClass(status?.[_.UPLOAD_CONTRACT_ID]),
      displayFor: _.DISPLAY_FOR_NON_MP,
    },
    {
      id: _.UPS_ACCOUNT,
      path: (profileId) => `/boarding/ops/17/${profileId}`,
      linkName: _.VP_MA_SB_PB_UPS_ACCOUNT,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PREBOARDING_UPSACCOUNT,
      statusColor: (status) => getStatusClass(status?.[_.UPS_ACCOUNT]),
      displayFor: _.DISPLAY_FOR_NON_MP,
    },
    {
      id: _.UPS_ACCOUNT,
      path: (profileId) => `/boarding/ops/17/${profileId}`,
      linkName: _.VP_MA_SB_PB_UPS_ACCOUNT,
      pageRoleId: null, // Display UPS Tab for all MP vendors
      statusColor: (status) => getStatusClass(status?.[_.UPS_ACCOUNT]),
      displayFor: _.DISPLAY_FOR_MP, // Display UPS tab for all MP vendors
    },
    {
      id: _.UPDATE_VENDOR_PROFILE,
      path: (profileId) => `/boarding/vendor/vendor-profile/${profileId}`,
      linkName: _.VP_MA_SB_PB_VENDOR_PROFILE,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PREBOARDING_VENDORPROFILE,
      statusColor: (status) =>
        getStatusClass(status?.[_.UPDATE_VENDOR_PROFILE]),
      displayFor: _.DISPLAY_FOR_NON_MP,
    },
  ],
};

export const integrationAccordion = {
  eventKey: "2",
  accordionName: _.VP_MA_SB_INT_HEAD,
  displayFor: _.DISPLAY_FOR_NON_MP,
  linkInfo: [
    {
      id: _.UPLOAD_PACKING_SLIP_ID,
      path: (profileId) => `/boarding/ops/10/${profileId}`,
      linkName: _.VP_MA_SB_INT_PS,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_PACKINGSLIP,
      statusColor: (status) =>
        getStatusClass(status?.[_.UPLOAD_PACKING_SLIP_ID]),
    },
    {
      id: _.UPLOAD_SHIPPING_LABEL_ID,
      path: (profileId) => `/boarding/ops/1/${profileId}`,
      linkName: _.VP_MA_SB_INT_SL,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_SHIPPINGLABEL,
      statusColor: (status) =>
        getStatusClass(status?.[_.UPLOAD_SHIPPING_LABEL_ID]),
    },
    {
      id: _.ORDER_TESTING_ID,
      path: (profileId) => `/boarding/ops/2/${profileId}`,
      linkName: _.VP_MA_SB_INT_ORDER,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_ORDERTESTING,
      statusColor: (status) => getStatusClass(status?.[_.ORDER_TESTING_ID]),
    },
    {
      id: _.TESTING_846_ID,
      path: (profileId) => `/boarding/ops/3/${profileId}`,
      linkName: _.VP_MA_SB_INT_846,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_846TESTING,
      statusColor: (status) => getStatusClass(status?.[_.TESTING_846_ID]),
    },
    {
      id: _.TABLE_SETUP,
      path: (profileId) => `/boarding/ops/13/${profileId}`,
      linkName: _.VP_MA_SB_INT_TABLE_SETUP,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_TABLESETUP,
      statusColor: (status) => getStatusClass(status?.[_.TABLE_SETUP]),
      checkVDF: _.TABLE_SETUP,
    },
    {
      id: _.QUALITY_LEADER_APPROVAL,
      path: (profileId) => `/boarding/ops/14/${profileId}`,
      linkName: _.VP_MA_SB_INT_QUALITY_LEADER,
      pageRoleId:
        rolePermConsts.VENDORPLATFORM_INTEGRATION_QUALITYLEADERAPPROVAL,
      statusColor: (status) =>
        getStatusClass(status?.[_.QUALITY_LEADER_APPROVAL]),
      checkVDF: _.QUALITY_LEADER_APPROVAL,
    },
    {
      id: _.EVP_AND_ERP_SETUP,
      path: (profileId) => `/boarding/ops/15/${profileId}`,
      linkName: _.VP_MA_SB_INT_EVP_AND_ERP_SETUP,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_EVPANDERPSETUP,
      statusColor: (status) => getStatusClass(status?.[_.EVP_AND_ERP_SETUP]),
      checkVDF: _.EVP_AND_ERP_SETUP,
    },
    {
      id: _.ITEM_SKU_SETUP,
      path: (profileId) => `/boarding/ops/16/${profileId}`,
      linkName: _.VP_MA_SB_INT_ITEM_SKU_SETUP,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_ITEMSKUSETUP,
      statusColor: (status) => getStatusClass(status?.[_.ITEM_SKU_SETUP]),
      checkVDF: _.ITEM_SKU_SETUP,
    },
    {
      id: _.BOSS_AGREEMENT,
      path: (profileId) => `/boarding/ops/4/${profileId}`,
      linkName: _.VP_MA_SB_INT_BOSS,
      pageRoleId: rolePermConsts.VENDORPLATFORM_INTEGRATION_BOSSAGREEMENT,
      statusColor: (status) => getStatusClass(status?.[_.BOSS_AGREEMENT]),
      checkVDF: _.BOSS_AGREEMENT,
    },
  ],
};

export const publishAccordion = {
  eventKey: "3",
  accordionName: _.VP_MA_SB_LIVE_HEAD,
  linkInfo: [
    {
      id: _.COMPLETE_VLL_ID,
      path: (profileId) => `/boarding/ops/5/${profileId}`,
      linkName: _.VP_MA_SB_LIVE_VLL,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PUBLISH_COMPLETEVLL,
      statusColor: (status) => getStatusClass(status?.[_.COMPLETE_VLL_ID]),
      displayFor: _.DISPLAY_FOR_NON_MP,
    },
    {
      id: _.PAGE_COMPLETE_ID,
      path: (profileId) => `/boarding/ops/6/${profileId}`,
      linkName: _.VP_MA_SB_LIVE_PAGE_CREATION,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PUBLISH_PAGECREATIONCOMPLETE,
      statusColor: (status) => getStatusClass(status?.[_.PAGE_COMPLETE_ID]),
      displayFor: _.DISPLAY_FOR_NON_MP,
    },
    {
      id: _.ONBOARDING_COMPLETE_ID,
      path: (profileId) => `/boarding/ops/12/${profileId}`,
      linkName: _.VP_MA_SB_LIVE_ONBOARD_COMPL,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PUBLISH_ONBOARDINGCOMPLETE,
      statusColor: (status) =>
        getStatusClass(status?.[_.ONBOARDING_COMPLETE_ID]),
      displayFor: _.DISPLAY_FOR_NON_MP,
    },
    {
      id: _.LIVE_ID,
      path: (profileId) => `/boarding/ops/7/${profileId}`,
      linkName: _.VP_MA_SB_LIVE_LIVE,
      pageRoleId: rolePermConsts.VENDORPLATFORM_PUBLISH_LIVE,
      statusColor: (status) => getStatusClass(status?.[_.LIVE_ID]),
    },
  ],
};
